import { render, staticRenderFns } from "./MyProfileMenuLayout.vue?vue&type=template&id=af16703e&scoped=true"
import script from "./MyProfileMenuLayout.vue?vue&type=script&lang=js"
export * from "./MyProfileMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16703e",
  null
  
)

export default component.exports